import { Box, Button, CircularProgress } from "@mui/material"
import React from "react"

export default function BtnCarregarDados({
    total,
    limit,
    isFetching,
    action
}: BtnCarregarDadosProps) {

    if (limit < total) return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            paddingY={2}
        >
            {
                isFetching &&
                <CircularProgress size={24} />
            }
            {
                !isFetching &&
                <Button
                    color="primary"
                    variant="outlined"
                    onClick={action}
                >Carregar mais</Button>
            }
        </Box>
    )

    return (
        <React.Fragment />
    )
}

interface BtnCarregarDadosProps {
    limit: number,
    total: number,
    isFetching: boolean,
    action: () => void
}